<label class="toggle-button-checkbox-label" for="toggle-button-checkbox">
    <input type="checkbox" id="toggle-button-checkbox" [(ngModel)]="toggledCheckboxValue"
           (ngModelChange)="onChange($event)">
    <div class="toggle-button-switch"></div>
    <div class="toggle-button-text">
        <div class="toggle-button-text-on">&nbsp;</div>
        <div class="toggle-button-text-off">&nbsp;</div>
    </div>
</label>
